import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.848 11.75c0 .492-.41.875-.875.875h-.875L18.125 17v.656a1.08 1.08 0 0 1-1.094 1.094h-2.187a1.063 1.063 0 0 1-1.094-1.094V15.25a.9.9 0 0 0-.875-.875h-1.75a.88.88 0 0 0-.875.875v2.406a1.08 1.08 0 0 1-1.094 1.094H6.97a1.063 1.063 0 0 1-1.094-1.094v-5.031H5a.864.864 0 0 1-.875-.875c0-.246.082-.465.273-.656l7-6.125c.192-.192.41-.219.602-.219.191 0 .41.055.574.191l6.973 6.153c.219.191.328.41.3.656"
    }, null, -1)
  ]))]))
}
export default { render: render }